import React, { useState, useRef, useEffect } from 'react';

const LazyImage = ({ 
  webpSrc, 
  fallbackSrc, 
  alt, 
  className = '', 
  threshold = 0.1,
  rootMargin = '50px'
}) => {
  const [isLoaded, setIsLoaded] = useState(false);
  const [isInView, setIsInView] = useState(false);
  const imgRef = useRef();

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !isInView) {
          setIsInView(true);
        }
      },
      { 
        threshold,
        rootMargin
      }
    );

    if (imgRef.current) {
      observer.observe(imgRef.current);
    }

    return () => observer.disconnect();
  }, [isInView, threshold, rootMargin]);

  const handleLoad = () => {
    setIsLoaded(true);
  };

  return (
    <div 
      ref={imgRef} 
      className={`lazy-image-container ${className}`}
    >
      {isInView && (
        <picture>
          {webpSrc && <source srcSet={webpSrc} type="image/webp" />}
          <img
            src={fallbackSrc}
            alt={alt}
            onLoad={handleLoad}
            className={`lazy-image ${isLoaded ? 'loaded' : 'loading'}`}
          />
        </picture>
      )}
      {!isInView && (
        <div className="lazy-placeholder">
          Loading...
        </div>
      )}
    </div>
  );
};

export default LazyImage; 